/**
 *
 * @param {*} parms {price,payType}
 * @param {*} finance {universal, special}
 */
export function payVerify(parms, finance, product = '') {
  console.log(parms, finance, product);
  let result = {
    msg: '',
    calc: 0,
    success: false,
  };

  switch (parms.payType) {
    case 0:
      result = calcCurrencyByOne(parms.price, finance.special, '专用币', product);
      break;
    case 1:
      result = calcCurrencyByTwo(parms.price, finance, product);
      break;
    case 2:
      result = calcCurrencyByOne(parms.price, finance.universal, '通用币',product);
      break;
  }
  return result;
}
/**
 * 单货币支付
 * @param {*} money
 * @param {*} balance
 * @param {*} CurrencyName
 */
function calcCurrencyByOne(money, balance, CurrencyName, product) {
  let result = {
    msg: '',
    calc: 0,
    success: true,
  };
  result.calc = balance - money;
  result.msg = `本次将支付${money}${product}${CurrencyName}，当前余额${balance}${product}${CurrencyName}，预计结账后余额${
    result.calc
  }${product}${CurrencyName}`;
  if (result.calc < 0) {
    result.success = false;
    result.msg = '账户余额不足,' + result.msg;
  }
  return result;
}
function calcCurrencyByTwo(money, finance, product) {
  let result = {
    msg: '',
    calc: 0,
    success: true,
  };
  let special = finance.special - money;
  if (special >= 0) {
    result.calc = special;
    result.msg = `本次将支付${money}${product}专用币，当前余额${
      finance.special
    }${product}专用币，预计结账后余额${special}${product}专用币`;
  } else {
    result.calc = finance.universal + special; //special当前为负数
    result.msg = `本次将支付${finance.special}${product}专用币 | ${Math.abs(special)}通用币，
            当前余额${finance.special}${product}专用币 | ${finance.universal}通用币，
            预计结账后余额0${product}专用币 | ${result.calc}通用币`;

    if (result.calc < 0) {
      result.success = false;
      result.msg = '账户余额不足,' + result.msg;
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/pay.js